@if (lp) {
  <router-outlet></router-outlet>
} @else {
  <div class="main">
    <app-header></app-header>
    <div class="contents" [class.width100]="isWidth100()">
      <router-outlet></router-outlet>
    </div>
  </div>
  @if (showChatWidget) {
    <app-chat-widget></app-chat-widget>
  }
}
